
import './App.css';
import Advice from './components/Advice'


function App(){

  

  return (
    <div className="App">
      <Advice />
    </div>
  );
}


export default App;



